import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVariablesAllQuery } from './useVariablesAllQuery'
import type { BadgeOption, BadgeTooltipLabels } from '@ai/ui-components'

export function useVariablesForMentions() {
  const { t } = useI18n()
  const { data } = useVariablesAllQuery()

  const variables = computed<BadgeOption[]>(() => {
    if (!data.value) return []
    return [...data.value]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((v) => ({
        name: v.name,
        description: v.description ?? '',
        detail: v.fallbackValue,
      }))
  })

  const tooltipLabels = computed<BadgeTooltipLabels>(() => ({
    name: t('variables.variable_name'),
    detail: t('variables.fallback_value'),
    description: t('description'),
  }))

  const missingBadgeTooltip = computed(() => t('variables.missing_badge_tooltip'))
  const invalidBadgeTooltip = computed(() => t('variables.invalid_badge_tooltip'))

  return { variables, tooltipLabels, missingBadgeTooltip, invalidBadgeTooltip }
}
